import { requireSupabase } from "../lib/supabase";

export function LoginScreen({ error }: { error: string | null }) {
  async function signIn() {
    const redirectTo = window.location.origin;
    const { error: authError } = await requireSupabase().auth.signInWithOAuth({
      provider: "google",
      options: { redirectTo },
    });
    if (authError) throw authError;
  }

  return (
    <main className="login-shell">
      <section className="login-copy">
        <div className="eyebrow">RESQ CHARITABLE TRUST</div>
        <h1>Every rescue story,<br />within reach.</h1>
        <div className="login-features">
          <span>Archive search</span><span>Follow-up ownership</span><span>Drive access</span>
        </div>
      </section>
      <section className="login-card">
        <img className="brand-logo" src="/resq-logo.png" alt="RESQ" />
        <h2>Media Portal</h2>
        <p>Use your approved RESQ Google account to continue.</p>
        {error && <div className="alert error">{error}</div>}
        <button className="google-button" onClick={() => void signIn()}>
          <span className="google-g">G</span>
          Continue with Google
        </button>
        <small>Access is restricted to approved RESQ team members.</small>
      </section>
    </main>
  );
}
